/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../objects/classes/appointmentquestion.ts" />
/// <reference path="../../wwwroot/scripts/typings/moment.d.ts" />
/// <reference path="../services/postcode.service.ts" />
/// <reference path="../factories/snackbar.factory.ts" />
/// <reference path="../services/data.service.ts" />

module App.Controllers
{
    export interface IAppointmentController extends IBaseController
    {

    }

    export class AppointmentController extends BaseController implements IAppointmentController, Interfaces.IStepController
    {
        static controllerId = 'appointmentController';

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            'calendarConfig',
            Services.PostcodeService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId,
            Services.DataService.serviceId
        ];

        stores: Classes.IStore[]
        selectedStore: Classes.IStore
        allAllowedStores: any[]
                
        availableDates: Interfaces.IDate[] = [];
        availableTimes: Interfaces.ITime[] = [];
        viewDate: Date = new Date();
        viewDate2: Date = moment(this.viewDate).add(1, 'M').toDate();
        calendarEvents: any[] = [];
        calendarView: string = 'month';
        selectedDate: Date
        selectedTime: Interfaces.ITime
        excludeDays: number[]
        replacementVehicleSelected: boolean = false;

        replacementVehicles: Interfaces.IReplacementVehicle[]
        selectedReplacementVehicle: Interfaces.IReplacementVehicle
        showFormErrors = false;
        showAddresLoader: boolean = false;
        showTimeLoader: boolean = false;

        needReplacement: boolean | null = null;
        wantToWait: boolean | null = null;

        waitForJob: boolean

        postcode: string
        houseNo: string
        street: string
        city: string
        enableDateSelection: boolean = true;

        nextStepNumber: string
        prevStepNumber: string
        stepName: string = Constants.routeKeys.appointment;

        preferredEstablishment: Classes.IStore

        calendarViewDate: Date = null

        enableQuestion: boolean = false
        questionTitle: string = ''
        questionOptions: Classes.AppointmentQuestion[] = []
        selectedQuestionOption: Classes.AppointmentQuestion
        questionInfoText: string = ''

        showBringEarlyOption: boolean = false
        selectedBringEarlyOption: string[] = []

        constructor($rootScope: Interfaces.IAppRootScope,
            $scope: ng.IScope,
            $q: ng.IQService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            composition: Interfaces.ICompositionService,
            calendarConfig: any,
            public postCodeService: App.Services.IPostcodeService,
            public snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService,
            private readonly dataService: App.Services.IDataService)
        {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory)

            calendarConfig.dateFormatter = 'moment'

            this.excludeDays = [0] // 0 is sunday

            this.nextStepNumber = (sessionService.maxStepNumber - 1).toString()
            this.prevStepNumber = (sessionService.maxStepNumber - 3).toString()

            if (this.sessionService.composition != null)
            {
                this.availableDates = this.sessionService.composition.dates
                this.resetCalendarView(this.selectedDate)
                this.availableTimes = this.sessionService.composition.times
                this.replacementVehicles = this.getValidProductForPickupService()
                this.enableDateSelection = this.sessionService.composition.enableDateSelection

                this.enableQuestion = this.sessionService.composition.enableQuestion
                this.questionTitle = this.sessionService.composition.questionTitle
                this.questionOptions = this.sessionService.composition.questionOptions
                this.selectedQuestionOption = this.sessionService.composition.selectedQuestionOption
                this.questionInfoText = this.sessionService.composition.questionInfoText

                this.showBringEarlyOption = this.sessionService.composition.bringBeforeAppointment
                this.selectedBringEarlyOption = this.sessionService.composition.selectedBringEarlyOption


                if (this.sessionService.composition.collectAddress != null)
                {
                    this.postcode = this.sessionService.composition.collectAddress.postalCode
                    this.street = this.sessionService.composition.collectAddress.street
                    this.houseNo = this.sessionService.composition.collectAddress.houseNumber
                    this.city = this.sessionService.composition.collectAddress.city
                }

                if (this.sessionService.composition.storeSelected)
                {
                    if (this.sessionService.composition.waitForJob != null)
                    {
                        this.wantToWait = this.sessionService.composition.waitForJob
                        this.waitForJob = this.sessionService.composition.waitForJob
                    }

                    if (this.sessionService.composition.stores != null)
                    {
                        this.stores = this.sessionService.composition.stores

                        this.getFirstAvailableStoreDates()

                        if (this.sessionService.composition.storeId != null)
                        {
                            this.selectedStore = this.stores.filter((d) =>
                            {
                                return d.id == this.sessionService.composition.storeId
                            })[0]
                        }
                    }
                }

                this.addDefaultTime()
                this.addDefaultReplacementVehicle()

                if (sessionService.composition != null)
                {
                    if ((sessionService.composition.selectedDate != null && this.availableDates != null) || (sessionService.composition.selectedDate != null && this.sessionService.composition.pipeline == Constants.configuratorTypes.summerWinterCheckPipelineName))
                    {
                        let selectedDate = moment(sessionService.composition.selectedDate)
                        if (selectedDate.year() > 1900)
                        {
                            let firstAvailable = selectedDate.toDate()

                            if (this.availableDates != null)
                            {
                                let availableDates = this.availableDates.filter(x => x.available > 0)

                                if (availableDates.length > 0) {
                                    firstAvailable = availableDates[0]
                                }
                            }

                            this.selectedDate = moment(sessionService.composition.selectedDate).toDate()                                                       
                            this.viewDate = firstAvailable.date
                            this.viewDate2 = moment(this.viewDate).add(1, 'M').toDate()
                            this.resetCalendarView(this.selectedDate)
                        }
                    }

                    if ((sessionService.composition.selectedTime != null && this.sessionService.composition.times != null) || (sessionService.composition.selectedTime != null && this.sessionService.composition.pipeline == Constants.configuratorTypes.summerWinterCheckPipelineName))
                    {
                        var selectedTimes = this.availableTimes.filter((d) =>
                        {
                            return d.time == sessionService.composition.selectedTime
                        })

                        if (selectedTimes.length > 0)
                            this.selectedTime = selectedTimes[0]
                    }

                    this.needReplacement = this.sessionService.composition.selectedReplacementVehicle != null

                    if (sessionService.composition.selectedReplacementVehicle != null)
                    {
                        this.needReplacement = this.sessionService.composition.selectedReplacementVehicle != null

                        if (sessionService.composition.selectedReplacementVehicle != null &&
                            sessionService.composition.selectedReplacementVehicle.name.indexOf("niet nodig") >= 0)
                        {
                            this.needReplacement = false
                            this.waitForJob = false
                        }

                        var vehicles = this.replacementVehicles.filter((d) =>
                        {
                            return d.name == sessionService.composition.selectedReplacementVehicle.name
                        })

                        if (vehicles.length > 0) {
                            this.selectedReplacementVehicle = vehicles[0]
                        }

                        this.replacementVehicleSelected = this.hasReplacementVehicleSelected()
                    }


                    if (this.isSummerWinterCheckPipelineName())
                    {
                        if (sessionService.composition.selectedDate != null)
                            this.selectedDate = moment(sessionService.composition.selectedDate).toDate()

                        if (sessionService.composition.storeSelected)
                            this.selectedStore = sessionService.composition.stores.filter((d) =>
                            {
                                return d.id == this.sessionService.composition.storeId
                            })[0]

                        this.enableDateSelection = false
                        this.availableTimes = sessionService.composition.times
                        this.wantToWait = false
                        this.needReplacement = sessionService.composition.requiresReplacementVehicle
                        this.stores = sessionService.composition.stores
                        for (let i = 0; i < this.stores.length; i++) {
                            let currentStore = this.stores[i]
                            currentStore.isVisible = true
                        }
                    }
                }
            }

            this.checkPageValidation()
        }

        getExpectYourCarText = () =>
        {
            let text = App.Functions.getExpectYourCarText(this.selectedReplacementVehicle,
                                                            App.Variables.currentSettelmentReplacementVehicleText,
                                                            App.Variables.globalReplacementVehicleText,
                                                            this.wantToWait,
                                                            this.selectedTime?.time,
                                                            this.sessionService.composition.pipeline)

            if (this.selectedQuestionOption != null && this.enableQuestion) {
                text = this.selectedQuestionOption.description
            }

            return text
        }

        hasReplacementVehicleSelected = () =>
        {
            return (this.selectedReplacementVehicle && this.selectedReplacementVehicle.name != Constants.defaultReplacementVehicleText)
        }

        getValidProductForPickupService = () =>
        {
            if (this.sessionService.composition && this.sessionService.composition.selectedProducts)
            {
                var maintenanceProducts = this.sessionService.composition.selectedProducts.filter((p) =>
                {
                    return p.type != Constants.productTypes.actions
                })

                let currentStoreShowAllReplacement = this.selectedStore?.alwaysAllowPickup ?? false

                if (maintenanceProducts.length > 0 || currentStoreShowAllReplacement)
                {
                    let maintenanceProductsCount = maintenanceProducts.filter((p) => {
                        return (p.name.toLowerCase() == Constants.noMaintenanceProductName)
                    }).length

                    if (maintenanceProductsCount == 0)
                    {
                        if (this.sessionService.composition.replacementVehicles != null)
                        {
                            return this.sessionService.composition.replacementVehicles
                        }
                    }
                }

                if (this.sessionService.composition.replacementVehicles == null)
                {
                    return []
                }

                let filteredReplacementVehicles = this.sessionService.composition.replacementVehicles.filter((p) =>
                {
                    if (p.name.toLowerCase().indexOf(Constants.replacementVehiclePickupTermTwo) != -1 || p.name.toLowerCase().indexOf(Constants.replacementVehiclePickupTermOne) != -1)
                    {
                        return false
                    }

                    return true
                })

                return filteredReplacementVehicles
            }

            return []
        }

        eventClicked = (event) =>
        {
        }

        changeView = (calendarDate: Date, calendarCell) =>
        {
            this.resetCalendarView(calendarDate)

            if (calendarCell.cssClass == 'available' || calendarCell.cssClass == 'last-available')
            {
                this.setDate(calendarDate)
                calendarCell.cssClass = 'selected-available'
            } else
                this.snackbarFactory.show('Datum is niet beschikbaar', 4000)

            this.resetCalendarView(calendarDate)
        }

        resetCalendarView = (calendarDate) => {
            this.calendarEvents = []

            this.calendarEvents.push({
                title: 'afspraak',
                startsAt: moment(calendarDate).startOf('day').toDate(),
                endsAt: moment(calendarDate).endOf('day').toDate(),
                color: '#ddaadd',
                draggable: true,
                resizable: true
            })

            let newDate: Date

            if (calendarDate == null) {
                if (this.availableDates != null) {
                    let availableDates = this.availableDates.filter(x => x.available > 0)

                    if (availableDates.length > 0) {
                        calendarDate = availableDates[0].date
                    } else {
                        calendarDate = moment().format()
                    }
                } else {
                    calendarDate = moment().format()
                }

                newDate = calendarDate
            } else {
                if ($(window).width() < 960) {
                    newDate = calendarDate
                } else {
                    newDate = this.viewDate
                }
            }
                        
            this.viewDate = moment(newDate).add(1, 'M').toDate()
            this.viewDate = moment(newDate).startOf('month').toDate()

            this.viewDate2 = moment(newDate).add(2, 'M').toDate()
            this.viewDate2 = moment(newDate).add(1, 'M').startOf('month').toDate()
        }

        cellModifier = (cell) =>
        {
            var cellDate = moment(cell.date)

            if (cellDate > moment())
            {
                if (this.availableDates != null)
                {
                    var isAvailable = this.availableDates.filter((d) =>
                    {
                        return moment(d.date).diff(cellDate, 'minutes') == 0 && d.available > 0
                    })

                    var currentMoment = null
                    if (this.selectedDate != null)
                    {
                        if (typeof (this.selectedDate) == "string")
                            this.selectedDate = new Date(this.selectedDate)
                        else
                            this.selectedDate = this.selectedDate

                        currentMoment = moment(this.selectedDate.setHours(0, 0))
                    }

                    if (isAvailable.length > 0 && isAvailable[0].available > 1)
                    {
                        if (currentMoment != null && currentMoment.diff(cellDate, 'minutes') == 0)
                            return cell.cssClass = 'selected-available'

                        return cell.cssClass = 'available'
                    } else if (isAvailable.length > 0 && isAvailable[0].available > 0)
                    {
                        if (currentMoment != null && currentMoment.diff(cellDate, 'minutes') == 0)
                            return cell.cssClass = 'selected-available'

                        return cell.cssClass = 'last-available'
                    } else cell.cssClass = 'not-available'

                }
            } else
                cell.cssClass = 'past-available'

            return null
        }

        goBackToStep()
        {
            if (this.isSummerWinterCheckPipelineName())
                this.goToStepIndex(0)
            else
                this.goToStepIndex(this.sessionService.maxStepNumber - 4)
        }

        hasDateTimeSelected()
        {
            if (this.wantToWait == false && this.selectedDate != null)
            {
                return true
            }
            return this.selectedDate != null &&
                (this.selectedTime != null && this.selectedTime.time != Constants.defaultTimeText)
        }

        getFormatedDate()
        {
            if (this.selectedDate != null)
                return moment(this.selectedDate).format('dddd DD MMMM')

            return ''
        }

        getFormatedTime()
        {
            if ((this.selectedTime != null && this.selectedTime.time != Constants.defaultTimeText))
                return 'om ' + this.selectedTime.time

            return ''
        }

        addDefaultTime()
        {
            if (this.availableTimes != null)
            {
                if (this.availableTimes.length > 0)
                {
                    if (this.selectedTime != null && this.selectedTime.time != null)
                    {
                        var selectedTime = this.availableTimes.filter((d) => { return d.time == this.selectedTime.time })[0]

                        if (selectedTime == null)
                        {
                            selectedTime = this.availableTimes[0]

                            this.setSelectTime(selectedTime)
                        }                        
                    }
                }
            }
        }

        addDefaultReplacementVehicle()
        {
            var replacementVehicle = new Classes.ReplacementVehicle()
            replacementVehicle.name = Constants.defaultReplacementVehicleText

            if (this.replacementVehicles != null)
            {
                if (this.sessionService.composition.selectedReplacementVehicle == null) {
                    this.replacementVehicles.unshift(replacementVehicle)
                }
                else {
                    this.selectedReplacementVehicle = this.sessionService.composition.selectedReplacementVehicle
                }

                if (this.replacementVehicles.length > 0 && this.selectedReplacementVehicle == null) {
                    this.selectedReplacementVehicle = this.replacementVehicles[0]
                }
            }

            this.replacementVehicleSelected = this.hasReplacementVehicleSelected()
        }

        isValid(isLogicCheck: boolean = false): boolean
        {
            this.showFormErrors = !isLogicCheck

            if (this.needReplacement && !this.waitForJob && this.selectedReplacementVehicle == null && this.replacementVehicles != null && this.replacementVehicles.length > 1)
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Selecteer een vervangend vervoer optie', 4000)
                    window.scrollTo(0, $(".replacement-option").first().position().top - 100)
                }
                return false
            }

            if (!this.needReplacement && !this.waitForJob && (this.sessionService.composition != null && this.sessionService.composition.replacementVehicles != null && this.sessionService.composition.replacementVehicles.length > 0))
            {
                this.selectedReplacementVehicle = this.sessionService.composition.replacementVehicles.filter((p) =>
                {
                    return p.name.indexOf("niet nodig") >= 0
                })[0]
            }

            if (this.wantToWait == null)
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Selecteer of u wilt wachten', 4000)
                    window.scrollTo(0, $(".wait-option").first().position().top - 100)
                }
                return false
            }

            if (this.selectedStore == null)
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Selecteer een geldige vestiging', 4000)
                    window.scrollTo(0, $(".location-option").first().position().top - 100)
                }
                return false
            }

            if (!this.hasDateTimeSelected())
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Selecteer een geldige datum en tijd', 4000)
                    window.scrollTo(0, $(".date-option").first().position().top - 100)
                }
                return false
            }

            if (this.showPickupForm() && this.$scope.replacementForm != undefined && !this.$scope.replacementForm.$valid)
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('Vul een geldig adres in voor de haal- en brengservice', 4000)
                    window.scrollTo(0, $(".delivery-service").first().position().top - 100)
                }
                return false
            }

            let composition = this.sessionService.composition

            if (this.selectedTime)
            {
                composition.selectedTime = this.selectedTime.time
            }

            if (this.selectedTime == null) {
                return false
            }


            composition.times = this.availableTimes
            composition.selectedQuestionOption = this.selectedQuestionOption
            composition.selectedBringEarlyOption = this.selectedBringEarlyOption

            if (this.selectedReplacementVehicle != null && this.replacementVehicles.length > 1) {
                composition.selectedReplacementVehicle = this.selectedReplacementVehicle
            } else {
                composition.selectedReplacementVehicle = null
            }

            if (this.showPickupForm())
            {
                if (composition.collectAddress == null) {
                    composition.collectAddress = new Classes.Address()
                }

                composition.collectAddress.postalCode = this.postcode
                composition.collectAddress.street = this.street
                composition.collectAddress.houseNumber = this.houseNo
                composition.collectAddress.city = this.city

                if (composition.deliverAddress == null) {
                    composition.deliverAddress = new Classes.Address()
                }

                composition.deliverAddress.postalCode = this.postcode
                composition.deliverAddress.street = this.street
                composition.deliverAddress.houseNumber = this.houseNo
                composition.deliverAddress.city = this.city
            } else
            {
                if (composition.collectAddress != null)
                {
                    composition.collectAddress.postalCode = ''
                    composition.collectAddress.street = ''
                    composition.collectAddress.houseNumber = ''
                    composition.collectAddress.city = ''
                }

                if (composition.deliverAddress != null)
                {
                    composition.deliverAddress.postalCode = ''
                    composition.deliverAddress.street = ''
                    composition.deliverAddress.houseNumber = ''
                    composition.deliverAddress.city = ''
                }
            }

            this.sessionService.composition = composition

            var selectedDate: Date = new Date(moment(this.selectedDate).year(),
                moment(this.selectedDate).month(),
                moment(this.selectedDate).day(),
                0,
                moment(this.selectedDate).utcOffset()
            )

            composition.selectedDate = <Interfaces.IDate>{ date: selectedDate }

            return true
        }


        showPickupForm = () =>
        {
            if (this.selectedReplacementVehicle != null && this.selectedReplacementVehicle.showPickupForm != null)
            {
                return this.selectedReplacementVehicle.showPickupForm
            }

            return false
        }

        isValidPostCode = () =>
        {
            return Constants.regexExp.postcode.test(this.postcode)
        }

        checkPostCodeAddress = () =>
        {
            if (this.isValidPostCode() && this.houseNo != null)
            {
                this.showAddresLoader = true

                var address = new Classes.Address
                address.houseNumber = this.houseNo
                address.postalCode = this.postcode

                if (this.postcode.length >= 6 && this.houseNo != '') {

                    this.postCodeService.requestAddress(address).then(
                        (result: Interfaces.IAddress) => {
                            this.street = result.street
                            this.city = result.city
                        }).catch((err) => {
                            this.street = ''
                            this.city = ''
                            this.snackbarFactory.show('Vul een geldig adres in voor de haal- en brengservice', 4000)
                        }).finally(() => {
                            this.showAddresLoader = false
                        })
                }
            }
        }

        setDate(calendarDate: Date)
        {
            this.selectedDate = new Date(moment(calendarDate).format('YYYY-MM-DD'))
            var self = this
            this.showTimeLoader = true
            self.availableTimes = []
            this.getTimes()
            this.resetCalendarView(this.selectedDate)
        }

        getTimes = () =>
        {
            var self = this
            var composition = this.sessionService.composition
            composition.selectedTime = null
            this.sessionService.composition = composition

            this.setCompositionValue(Constants.apiServiceStateCalls.selectedDate, this.selectedDate, false).then(
                (result: Classes.IComposition) =>
                {
                    self.availableTimes = result.times

                    if (this.wantToWait) {
                        self.availableTimes = result.allowWaitingTimes
                    }

                    self.addDefaultTime()

                    if (!self.ShowTimes()) {
                        self.selectedTime = self.availableTimes[0]

                        if (self.selectedTime) {
                            this.setSelectTime(self.selectedTime)
                        }
                    }

                    if (this.showBringEarlyQuestion()) {
                        this.scrollToElementId('papendrecht-question')
                    } else {
                        this.scrollBottom()
                    }
                    

                    this.checkPageValidation()

                }).catch((err) =>
                {
                    this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw.', 4000)
                    console.log('error setCompositionValue selectedDate: ' + JSON.stringify(err))
                }).finally(() =>
                {
                    this.showTimeLoader = false
                })
        }

        increaseCalender1 = () =>
        {
            this.viewDate = moment(this.viewDate).add(1, 'M').startOf('month').toDate()
        }

        decreaseCalender1 = () =>
        {
            this.viewDate = moment(this.viewDate).add(-1, 'M').startOf('month').toDate()
        }

        setNeedReplacementChanged = (needReplacement) =>
        {
            this.needReplacement = needReplacement
            this.selectedDate = null
            this.selectedTime = null
            this.availableDates = []
            this.replacementVehicles = this.sessionService.composition.replacementVehicles
            this.enableDateSelection = this.sessionService.composition.enableDateSelection
            this.selectedReplacementVehicle = null

            let composition = this.sessionService.composition
            composition.requiresReplacementVehicle = needReplacement
            this.sessionService.composition = composition

            if (!needReplacement) {
                this.selectedReplacementVehicle = null
                this.doStorePostGetDates()
            } else {
                this.selectedQuestionOption = null
                this.getDateReplacementVehicleChanged()
            }
        }

        replacementVehiclesChanged = () =>
        {
            if (this.selectedReplacementVehicle != null && this.replacementVehicles.length > 0)
            {
                let composition = this.sessionService.composition
                composition.selectedReplacementVehicle = this.selectedReplacementVehicle
                this.sessionService.composition = composition

                this.doStorePostGetDates()
            }

            this.replacementVehicleSelected = this.hasReplacementVehicleSelected()
        }

        QuestionChanged = () => {
            if (this.selectedQuestionOption != null && this.enableQuestion) {
                let composition = this.sessionService.composition
                composition.selectedQuestionOption = this.selectedQuestionOption
                this.sessionService.composition = composition
            }

            this.$scope.$emit(Constants.broadcast.compositionChange)
            this.scrollBottom()            
        }

        showQuestionForm = () => {
            if (this.enableQuestion && this.selectedStore != null && (!this.needReplacement && this.needReplacement != null)) {
                return true
            }
            return false

        }

        showDateSelection = () => {
            let showQuestion = this.enableQuestion && (this.selectedQuestionOption != null) && !this.wantToWait
            let questionFilled = this.selectedQuestionOption != null
            let questionCorrect = !showQuestion || (showQuestion && questionFilled)

            if (this.enableDateSelection && questionCorrect) {
                return true
            }

            return false
        }

        doStorePostGetDates = () =>
        {
            let self = this
            this.showTimeLoader = true
            this.enableQuestion = false

            this.setCompositionValue(Constants.apiServiceStateCalls.storeId, this.selectedStore.id, false).then(
                (result: Classes.IComposition) =>
                {
                    if (result.dates != null) {
                        self.availableDates = result.dates
                    }

                    self.resetCalendarView(self.selectedDate)
                    self.enableDateSelection = result.enableDateSelection

                    if (!result.enableDateSelection)
                    {
                        let selectedDate = moment(result.selectedDate)
                        self.selectedDate = selectedDate
                        self.availableTimes = result.times

                        self.getTimes()

                        if (this.wantToWait) {
                            self.availableTimes = result.allowWaitingTimes
                        }
                    }

                    self.enableQuestion = result.enableQuestion
                    self.questionTitle = result.questionTitle
                    self.questionOptions = result.questionOptions
                    self.questionInfoText = result.questionInfoText
                    self.showBringEarlyOption = result.bringBeforeAppointment
                    self.selectedBringEarlyOption = result.selectedBringEarlyOption

                    let composition = this.sessionService.composition
                    composition.enableQuestion = result.enableQuestion
                    composition.questionTitle = result.questionTitle
                    composition.questionOptions = result.questionOptions
                    composition.selectedBringEarlyOption = result.selectedBringEarlyOption
                    this.sessionService.composition = composition

                    if (self.selectedReplacementVehicle && self.selectedReplacementVehicle.name.toLowerCase().indexOf(Constants.replacementVehiclePickupTermOne) >= 0) {
                        window.scrollTo(0, $(".delivery-service").first().position().top - 100)
                    }
                    else {

                        // check key & go
                        if (this.selectedQuestionOption != null && this.enableQuestion) {
                            window.scrollTo(0, $(".extra-question").first().position().top - 100)
                        } else {
                            this.scrollBottom()
                        }
                        
                    }

                }).catch((err) =>
                {
                    this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw.', 4000)
                    console.log('error doStorePostGetDates: ' + JSON.stringify(err))
                }).finally(() =>
                {
                    this.showTimeLoader = false
                })
        }


        getDateReplacementVehicleChanged = () =>
        {
            let self = this
            this.selectedDate = null
            this.selectedTime = null
            this.showTimeLoader = true

            let composition = this.sessionService.composition
            composition.storeId = this.selectedStore.id
            this.sessionService.composition = composition

            this.setCompositionValue(Constants.apiServiceStateCalls.selectedReplacementVehicle, this.selectedReplacementVehicle, false).then(
                (result: Classes.IComposition) =>
                {
                    var validProductForPickupService = this.getValidProductForPickupService()

                    if (self.replacementVehicles.length != validProductForPickupService.length) {
                        self.replacementVehicles = validProductForPickupService
                    }

                    this.replacementVehicleSelected = this.hasReplacementVehicleSelected()

                    if (this.isSummerWinterCheckPipelineName())
                    {
                        this.selectedDate = moment(result.selectedDate).toDate()
                        this.enableDateSelection = false
                        this.needReplacement = result.requiresReplacementVehicle
                        this.availableTimes = result.times
                    }

                    this.availableDates = result.dates
                    this.resetCalendarView(this.selectedDate)
                    this.scrollBottom()

                }).catch((err) =>
                {
                    this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw.', 4000)
                    console.log('error setCompositionValue selectedDate: ' + JSON.stringify(err))
                }).finally(() =>
                {
                    this.showTimeLoader = false
                })

        }

        locationsByWaiting = (choice: boolean) =>
        {
            let self = this

            if (self.wantToWait != choice)
            {
                self.selectedStore = null
                self.needReplacement = null
                self.selectedDate = null
                self.selectedTime = null
                self.stores = []
                self.showTimeLoader = true
                self.wantToWait = choice
                self.replacementVehicles = []
                self.selectedReplacementVehicle = null
                self.selectedBringEarlyOption = []
                self.showBringEarlyOption = false

                let composition = this.sessionService.composition
                composition.storeSelected = false
                composition.collectAddress = null
                composition.allAllowedStores = null
                composition.selectedReplacementVehicle = null
                composition.selectedDate = null
                composition.selectedBringEarlyOption = []
                composition.selectedProducts = composition.selectedProducts.filter(x => x.name !== Constants.waitForSearchPhrase);

                this.postcode = ""
                this.houseNo = ""
                this.street = ""
                this.city = ""
                this.sessionService.composition = composition

                if (choice == false)
                {
                    if (this.selectedReplacementVehicle != null) {
                        this.selectedReplacementVehicle.showPickupForm = false
                    }
                }

                this.setCompositionValue(Constants.apiServiceStateCalls.waitForJob, choice, false).then(
                    (result: Classes.IComposition) =>
                    {
                        if (result != null && result.stores != null) {
                            self.stores = result.stores
                        }

                        this.getFirstAvailableStoreDates()
                        this.scrollToElementId('choose-location')

                        self.wantToWait = choice
                    }).catch((err) =>
                    {
                        this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw.', 4000)
                        console.log('error setCompositionValue selectedDate: ' + JSON.stringify(err))
                    }).finally(() =>
                    {
                        self.showTimeLoader = false
                    })
            }
        }

        setSelectedStore = () =>
        {
            this.needReplacement = null
            this.availableDates = []
            this.selectedDate = null
            this.selectedTime = null
            this.replacementVehicles = []
            this.selectedReplacementVehicle = null
            this.selectedQuestionOption = null
            this.selectedBringEarlyOption = []
            this.showBringEarlyOption = false

            this.getReplacementVehicleTexts(this.selectedStore.id)

            let composition = this.sessionService.composition
            let selectedStore = composition.stores.filter(x => x.id == this.selectedStore.id)            
            composition.storeSelected = true
            composition.replacementVehicles = []
            composition.dates = []
            composition.selectedDate = null
            composition.selectedTime = null
            composition.selectedReplacementVehicle = null

            if (selectedStore != null && selectedStore.length > 0) {
                composition.storeName = selectedStore[0].name
            }

            this.sessionService.composition = composition

            if (this.isSummerWinterCheckPipelineName()) {
                this.needReplacement = false
            }

            if (this.wantToWait || this.isSummerWinterCheckPipelineName()) {
                this.doStorePostGetDates()
            }
            else {
                this.scrollBottom()
            }

            this.$scope.$emit(Constants.broadcast.compositionChange)
        }

        getReplacementVehicleTexts = (storeId) => {
            this.compositionService.getReplacementVehicleTexts(storeId.toString()).then((result: any) => {
                App.Variables.globalReplacementVehicleText = []
                App.Variables.currentSettelmentReplacementVehicleText = []

                for (let i = 0; i < result.currentSettelmentReplacementVehicleText.length; i++) {
                    App.Variables.currentSettelmentReplacementVehicleText.push(
                        {
                            code: result.currentSettelmentReplacementVehicleText[i].code,
                            description: result.currentSettelmentReplacementVehicleText[i].description
                        })
                }
                for (let i = 0; i < result.globalReplacementVehicleText.length; i++) {
                    App.Variables.globalReplacementVehicleText.push(
                        {
                            code: result.globalReplacementVehicleText[i].code,
                            description: result.globalReplacementVehicleText[i].description
                        })
                }
            })
        }

        setSelectTime = (time) =>
        {
            this.selectedTime = time
            let composition = this.sessionService.composition
            composition.selectedTime = this.selectedTime.time
            this.sessionService.composition = composition
            this.setCompositionValue("selectedTime", this.selectedTime.time, false).then(
                () =>
                {
                }).catch((err) =>
                {
                    this.snackbarFactory.show('Fout met opslaan, probeer het opnieuw.', 4000)
                    console.log('error setCompositionValue selectedTime: ' + JSON.stringify(err))
                }).finally(() =>
                {
                    this.showTimeLoader = false
                })
        }

        scrollBottom = () =>
        {
            setTimeout(function ()
            {
                window.scrollTo(0, document.body.scrollHeight)
            },
                100)
        }

        scrollToElementId = (elementId) => {
            let elementTop = $('#' + elementId).offset().top
            let headerHeight = 188
            let scrollPosition = elementTop - headerHeight

            setTimeout(function () {
                window.scrollTo(0, scrollPosition)
            }, 100)
        }

        isSummerWinterCheckPipelineName = () =>
        {
            return this.sessionService.composition.pipeline == Constants.configuratorTypes.summerWinterCheckPipelineName
        }

        getFirstAvailableStoreDates = () =>
        {
            let storeIds = this.sessionService.composition.stores.map(x => x.id)
            let selectProductNames = this.sessionService.composition.selectedProducts.map(x => x.name)
            let self = this
            let composition = this.sessionService.composition
            this.allAllowedStores = []

            for (var j = 0; j < storeIds.length; j++)
            {
                this.dataService.getFirstStoreDates([storeIds[j]], selectProductNames, self.wantToWait).then(
                    (result: App.Interfaces.IStoreDate[]) =>
                    {
                        if (result['status'] && result['status'] == 500)
                        {
                            return
                        }

                        for (let i = 0; i < composition.allAllowedStores.length; i++)
                        {
                            let storeId = composition.allAllowedStores[i].id
                            let storeAvaibleDateResult = result.filter(x => x.storeId == storeId.toString())
                            let currentStore = self.stores.find(x => x.id == storeId)

                            if (storeAvaibleDateResult != null && storeAvaibleDateResult.length > 0)
                            {
                                composition.allAllowedStores[i].firstAvailableDate = storeAvaibleDateResult
                                    .filter(x => x.date !== null)
                                    .map(x => x.date)[0]

                                self.allAllowedStores.push(composition.allAllowedStores[i])

                                //When there are no first avaible date the store should be hidden
                                if (composition.allAllowedStores[i].firstAvailableDate == undefined && !this.isSummerWinterCheckPipelineName())
                                {
                                    currentStore.isVisible = false
                                    return
                                }
                                currentStore.isVisible = true
                            }
                        }
                    }).catch((err) =>
                    {
                        console.log('error getFirstAvailableStoreDates: ' + err)
                    }).finally(() =>
                    {
                        if (self.allAllowedStores.length == storeIds.length)
                        {
                            self.stores = self.stores
                            this.sessionService.composition = composition
                        }
                    })
            }


        }

        getFirstAvailableDate = (store) =>
        {
            if (this.allAllowedStores == null) {
                return ''
            }

            // the aalease and summer/wintercheck are service that are only on specific dates. 
            // That's why we don't return a available date 
            if (this.sessionService.composition.pipeline == Constants.configuratorTypes.summerWinterCheckPipelineName
                || this.sessionService.composition.pipeline == Constants.configuratorTypes.tyreChangeAaPipelineName)
                return ''


            let allowedStore = this.allAllowedStores.filter((x) =>
            {
                return x.id == store.id
            })[0]


            if (allowedStore != null && allowedStore.firstAvailableDate != null)
            {
                if (allowedStore.planItHideFirstAvailabled)
                {
                    return ''
                }
                return moment(allowedStore.firstAvailableDate).format('dddd DD MMMM')
            }


            return ''
        }

        ShowTimes = () =>
        {
            if (this.sessionService.composition.pipeline == Constants.configuratorTypes.summerWinterCheckPipelineName || this.wantToWait) {
                return true
            }

            return false
        }

        customAvailableText = (store) =>
        {
            if (!store)
            {
                return ""
            }
            return store.plainitDateCustomText
        }

        setBringEarlier = (option) =>
        {
            this.selectedBringEarlyOption = []
            this.selectedBringEarlyOption.push(option)
        }

        showTimeStep = () => {
            return this.selectedDate != null && (this.availableDates.length > 0 || !this.enableDateSelection) && this.selectedStore != null && ((this.needReplacement == false || this.wantToWait) || (this.needReplacement == true && this.replacementVehicleSelected))
        }

        BringEarlyOptionIsSelected = (option) =>
        {
            return this.selectedBringEarlyOption.indexOf(option) >= 0
        }

        GetBringEarlyOptionDayBeforeText = () => {
            return App.Variables.BringEarlyOptionDayBeforeText
        }

        GetBringEarlyOptionEarlyText = () => {
            return App.Variables.BringEarlyOptionEarlyText
        }

        GetBringEarlyOptionEveningText = () => {
            return App.Variables.BringEarlyOptionEveningText
        }

        GetBringEarlyOptionNoText = () => {
            return App.Variables.BringEarlyOptionNoText
        }

        showBringEarlyQuestion = () => {
            return this.showBringEarlyOption && !this.wantToWait && this.showTimeStep()
        }
    }

    app.controller(AppointmentController.controllerId, AppointmentController)
}